import { useEffect, useState } from 'react';

export const useBrowserPermission = ({
  permissionName,
  skip,
}: {
  permissionName: PermissionName;
  skip?: boolean;
}): { hasPermission: boolean; hasCheckedPermission: boolean } => {
  const [hasPermission, setHasPermission] = useState(false);
  const [hasCheckedPermission, setHasCheckedPermission] = useState(false);

  useEffect(() => {
    if (!skip && !hasPermission && 'mediaDevices' in navigator && permissionName === 'microphone') {
      (navigator as Navigator).mediaDevices
        .getUserMedia({ audio: true })
        .then((mediaStream) => {
          setHasPermission(!!mediaStream);
          mediaStream.getTracks().forEach((track) => track.stop());
        })
        .catch((e) => console.error('Error getting microphone permission with getUserMedia()', e))
        .finally(() => {
          setHasCheckedPermission(true);
        });
    }
  }, [permissionName, skip, hasPermission]);

  return { hasPermission, hasCheckedPermission };
};
